import { render, staticRenderFns } from "./StationPlaceTable.vue?vue&type=template&id=28b0ea7e&scoped=true&"
import script from "./StationPlaceTable.vue?vue&type=script&lang=js&"
export * from "./StationPlaceTable.vue?vue&type=script&lang=js&"
import style0 from "./StationPlaceTable.vue?vue&type=style&index=0&id=28b0ea7e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0ea7e",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaceTable.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b0ea7e')) {
      api.createRecord('28b0ea7e', component.options)
    } else {
      api.reload('28b0ea7e', component.options)
    }
    module.hot.accept("./StationPlaceTable.vue?vue&type=template&id=28b0ea7e&scoped=true&", function () {
      api.rerender('28b0ea7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaces/StationPlaceTable.vue"
export default component.exports